import { clsx } from 'clsx';
import { FormattedMessage } from 'react-intl';
import BlockTitle from '../../../layout/BlockTitle';
import GrayBox from '../../../layout/GrayBox';
import { useLocale } from '../../../../lang/LocalizationProvider';
import { getLink } from '../../../../common/FormatMessageComponents';
import generalStyles from '../RouterSettingsSection.scss';
import styles from './RouterFAQBlock.scss';

const RouterFAQBlock = () => {
  const { selectedLocalization } = useLocale();

  const faqLink =
    selectedLocalization === 'uk'
      ? 'https://support.clearvpn.com/hc/uk/articles/18459229236508'
      : 'https://support.clearvpn.com/hc/en-us/articles/18459229236508';

  return (
    <article>
      <BlockTitle>
        <FormattedMessage
          id="profile.routerSection.helpBlock.title"
          defaultMessage="Learn more about VPN for routers"
        />
      </BlockTitle>
      <GrayBox className={clsx(generalStyles.text, styles.helpBlock)}>
        <span>
          <FormattedMessage
            id="profile.routerSection.helpBlock.guideLink"
            defaultMessage="Follow <a>the setup guide</a>"
            values={{
              a: getLink(faqLink, true),
            }}
          />
        </span>
        <span>
          <FormattedMessage
            id="profile.routerSection.helpBlock.learnMoreLink"
            defaultMessage="Get more tips on <a>how to enhance your cybersecurity</a>"
            values={{
              a: getLink('https://clearvpn.com/security-checklist/', true),
            }}
          />
        </span>
        <span>
          <FormattedMessage
            id="profile.routerSection.helpBlock.helpCenterLink"
            defaultMessage="Have more questions? Reach out our <a>Help center</a>"
            values={{
              a: getLink('https://support.clearvpn.com/hc', true),
            }}
          />
        </span>
      </GrayBox>
    </article>
  );
};

export default RouterFAQBlock;
